<template>
    <div class="card mb-0 shadow">
        <div class="card-body">
            <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                    <h4>Cadastramento de Atividade</h4>
                </div>
            </div>

            <form @submit.prevent="submit" ref="addItem">  
                <div class="row">
                    <form-input
                        v-model="atividade.atividade"
                        label="Atividade:"
                        required
                    />
                    <form-input
                        v-model="atividade.frequencia"
                        label="Frequência:"
                        grid="6"
                        required
                    />
                    <form-input
                        v-model="atividade.local"
                        label="Local da atividade:"
                        grid="6"
                        required
                    />
                    <form-input
                        v-model="atividade.objetivo"
                        label="Objetivo:"
                        required
                    />
                    <form-input
                        v-model="atividade.data_atividade"
                        label="Data:"
                        grid="6"
                        type="date"
                        required
                    />
                    <form-input
                        v-model="atividade.hora_atividade"
                        label="Hora:"
                        grid="6"
                        type="time"
                        required
                    />
                </div>
                <div class="row col-12 pb-3 px-0 m-0 d-flex justify-content-end">
                    <button class="btn btn-success m-0 btn-submit" data-style="zoom-in" type="submit">
                        Salvar
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            atividade: {
                atividade: '',
                frequencia: '',
                local: '',
                objetivo: '',
                data_atividade: '',
                hora_atividade: '',
            },
        };
    },
    methods: {
        async submit() {
            const camposObrigatorios = [
                'atividade', 'frequencia', 'local', 'objetivo',
                'data_atividade', 'hora_atividade'
            ];

            for (let campo of camposObrigatorios) {
                if (!this.atividade[campo]) {
                    this.$snack.warning({ text: 'Preencha todos os campos obrigatórios.' });
                    return;
                }
            }

            const payload = {
                ...this.atividade,
                acolhimento_id: this.item.id,
            };

            try {
                const response = await axios.post("api/dashboard/acolhimento/idoso/atividades/store", payload);
                const idAtividade = response?.data?.id;

                this.$snack.success({ text: "Atividade cadastrada com sucesso!" });

                // Redireciona se idAtividade existir
                if (idAtividade) {

                    if (!payload.status) {
                        payload.status = "Aberto";
                    }
                    
                    this.$emit("atividadeCriada", { id: idAtividade, ...payload });
                }

            } catch (e) {
                this.$snack.error({ text: "Erro ao salvar a atividade." });
            }
        }

    }
};
</script>
